export const popups = {
  'error.code': {
    text: 'serverError',
    buttons: ['reload'],
    retry: false,
  },
  'error.request.params': {
    text: 'serverError',
    buttons: ['reload'],
    retry: false,
  },

  'error.restricted-country': {
    img: 'brand/images/greyLogo.png',
    buttons: ['reload'],
    retry: false,
  },

  'error.request.bad':
    {
      text: 'serverError',
      buttons: ['reload'],
      retry: false,
    },

  'error.validation': {
    text: 'serverError',
    buttons: ['reload'],
    retry: false,
  },

  'error.game': {
    text: 'serverError',
    buttons: ['reload'],
    retry: false,
  },
  'error.integration': {
    text: 'serverError',
    buttons: ['reload'],
    retry: false,
  },

  'error.integration.balance': {
    text: 'balanceTopUp',
    buttons: ['deposit'],
    retry: false,
  },

  'error.integration.token': {
    text: 'sessionExpired',
    buttons: ['reload'],
    retry: false,
  },

  'error.integration.betLimit': {
    text: 'balanceLow',
    buttons: ['reload', 'deposit'],
    retry: false,
  },

  'error.token': {
    text: 'sessionExpired',
    buttons: ['reload'],
    retry: false,
  },

  'error.server': {
    text: 'serverError',
    buttons: ['reload'],
    retry: false,
  },

  'limitExceeded': {
    buttons: ['ok'],
    text: 'limitExceeded',
    retry: false,
  },
  'sessionExpired': {
    buttons: ['reload'],
    text: 'sessionExpired',
    retry: false,
  },
  'balanceLow': {
    buttons: ['ok', 'adjust', 'deposit'],
    text: 'balanceLow',
    retry: false,
  },
  'balanceTopUp': {
    buttons: ['ok', 'deposit'],
    text: 'balanceTopUp',
    retry: false,
  },
  'internetConnection': {
    buttons: ['reload'],
    text: 'internetConnection',
    retry: false,
  },
  'networkError': {
    buttons: ['reload'],
    text: 'networkError',
    retry: false,
  },
  'serverError': {
    buttons: ['reload'],
    text: 'serverError',
    retry: false,
  },
  'error.integration.unknownError': {
    buttons: ['reload'],
    text: 'serverError',
    retry: true,
  },
  'error.integration.internalError': {
    buttons: ['reload'],
    text: 'serverError',
    retry: true,
  },
  'error.integration.timeout': {
    buttons: ['reload'],
    text: 'serverError',
    retry: true,
  },
  'error.integration.userBlockedByExclusion': {
    buttons: [],
    text: 'BlockedByExclusion',
    retry: false,
  },
  'error.integration.maxLossLimit': {
    buttons: [],
    text: 'LossLimit',
    retry: false,
  },
  'error.integration.maxBetLimit': {
    buttons: [],
    text: 'BetLimit',
    retry: false,
  },
}
